import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MpSnackbarService } from '../widgets/mp-snackbar/mp-snackbar.service';
import { MpSnackbarTypes } from '../widgets/mp-snackbar/mp-snackbar.model';

@Injectable({
  providedIn: 'root'
})
export class SnackBarService {
  constructor(private mpSnackbarService: MpSnackbarService, private translate: TranslateService) {}

  /**
   * open snackbar with desired text and class
   * @param string text to display
   * @param boolean false if is error snackbar, else put nothing
   * @returns void
   */
  public openSnackBar(text: string, isOK = true, duration?: number): void {
    const translation = this.translate.instant(text);
    if (!duration) {
      duration = isOK ? 2000 : 50000;
    }

    this.mpSnackbarService.openSnackbar(translation, isOK ? MpSnackbarTypes.SUCCESS : MpSnackbarTypes.ERROR, { duration });
  }
}
